import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import DestionationWrapper from "./DestionationWrapper";

function Destinatination() {
  return (
    <>
      <Breadcrumb name="Destination" />
      <DestionationWrapper />
    </>
  );
}

export default Destinatination;
